// src/components/aiTalentDrive/api.ts
// Where the drive's public endpoints live (babblebots-monolith
// django_backend/urls.py, hiring-circuit/*). One place for the pieces that
// talk to it: the join flow and the live talent-pool block.
export const API_BASE =
  process.env.REACT_APP_HIRING_CIRCUIT_API ||
  (typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "http://localhost:8000"
    : "https://interview.babblebots.ai");
